import { NaniumObject, RequestType } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { User } from "../../entities/user.entity";

export class UserGetRequestBody extends NaniumObject<UserGetRequestBody> {
	id?: string;
}

@RequestType({
	responseType: User,
	genericTypes: { TRequestBody: UserGetRequestBody },
	scope: 'public'
})
export class UserGetRequest extends ServiceRequestBase<UserGetRequestBody, User> {
	static serviceName: string = 'NaniumDemo:user/get';
}
